<div class="c-error-page galec-403">
    <app-change-lang></app-change-lang>
    <div class="c-card">
        <img src="../assets/img/logo/galec-iam-logo-bleu.svg" class="w-100" alt="IAM Logo"/>
        <div class="c-error__title mt-3">{{ 'CATEGORIES.MAINTENANCE.TITRE' | translate }}</div>
        <div class="c-error__desc">
            {{ 'CATEGORIES.MAINTENANCE.SITE_INDISPONIBLE' | translate }} <br/>
            {{ 'CATEGORIES.MAINTENANCE.A_BIENTOT' | translate }}
        </div>
    </div>
</div>
